import React from 'react';
import './App.css';
import Implementor from './Implementor';

function App() {
  return (
    <div className="App">
      <Implementor />
    </div>
  );
}

export default App;
